import type { DataTableColumn } from '@/components/custom/erp';
import type { TaiKhoanCuaHang } from '@/types/schemas';

export const getDataTableColumns = (): DataTableColumn<TaiKhoanCuaHang>[] => [
  { field: 'ma_cuahang', headerName: 'Mã cửa hàng', width: 120 },
  {
    field: 'ma_kho',
    headerName: 'Mã kho',
    width: 120,
    renderCell: params => {
      const row = params.row as TaiKhoanCuaHang;

      return <span>{row.ma_kho_data?.ma_kho || ''}</span>;
    }
  },
  {
    field: 'ten_kho',
    headerName: 'Tên kho',
    width: 200,
    renderCell: params => {
      const row = params.row as TaiKhoanCuaHang;

      return <span>{row.ma_kho_data?.ten_kho || ''}</span>;
    }
  },
  {
    field: 'ma_bp',
    headerName: 'Mã bộ phận',
    width: 120,
    renderCell: params => {
      const row = params.row as TaiKhoanCuaHang;

      return <span>{row.ma_bp_data?.ma_bp || ''}</span>;
    }
  },
  {
    field: 'ten_bo_phan',
    headerName: 'Tên bộ phận',
    width: 200,
    renderCell: params => {
      const row = params.row as TaiKhoanCuaHang;

      return <span>{row.ma_bp_data?.ten_bp || ''}</span>;
    }
  },
  {
    field: 'tk_cong_no_phai_thu',
    headerName: 'Tk công nợ phải thu',
    width: 150,
    renderCell: params => {
      const row = params.row as TaiKhoanCuaHang;

      return <span>{row.tk_cn_data?.code || ''}</span>;
    }
  },
  {
    field: 'tk_cong_no_phai_tra',
    headerName: 'Tk công nợ phải trả',
    width: 150,
    renderCell: params => {
      const row = params.row as TaiKhoanCuaHang;

      return <span>{row.tk_cn2_data?.code || ''}</span>;
    }
  },
  {
    field: 'tk_tien_mat',
    headerName: 'Tk tiền mặt',
    width: 120,
    renderCell: params => {
      const row = params.row as TaiKhoanCuaHang;

      return <span>{row.tk_tm_data?.code || ''}</span>;
    }
  },
  {
    field: 'status',
    headerName: 'Trạng thái',
    width: 120,
    renderCell: params => {
      const row = params.row as TaiKhoanCuaHang;

      return <span>{row.status === 1 ? '1. Còn sử dụng' : '0. Không sử dụng'}</span>;
    }
  }
];
